import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AccountAggregatorUrl, NetBankingUrl } from "./net-banking.interface";
import { PlatformInfo } from "src/app/shared/common.interface";

@Injectable({
    providedIn: "platform",
})
export class NetBankingService {
    baseUrl = `${environment.baseUrl}`;

    constructor(private http: HttpClient) {}

    getAABankList() {
        return this.http.get<any>(`${this.baseUrl}/netbanking/aa/bank/list`);
    }

    getMobileList() {
        return this.http.get<any>(`${this.baseUrl}/netbanking/mobile/list`);
    }

    accountAggregatorUrl(req: AccountAggregatorUrl) {
        return this.http.post<any>(`${this.baseUrl}/netbanking/account/aggregator/url`, req);
    }

    getBankDetails() {
        return this.http.get<any>(`${this.baseUrl}/netbanking/aa/last/application/bank/details`);
    }

    declineConsent(consentId: string) {
        return this.http.put<any>(`${this.baseUrl}/netbanking/aa/last/application/consent/decline/${consentId}`, {});
    }

    rejectConsent() {
        return this.http.put<any>(`${this.baseUrl}/netbanking/aa/back/event/failed/consent`, {});
    }

    periodicConsent() {
        return this.http.get<any>(`${this.baseUrl}/netbanking/account/aggregator/periodic/consent`, {});
    }

    aggregatorCallback(customerId: string, status: string) {
        const requestType = "CONSENT";
        const platform = PlatformInfo.WEB.value;
        return this.http.get<any>(
            `${this.baseUrl}/netbanking/account/aggregator/callback/${customerId}/${requestType}/${platform}`,
            {
                params: { status: status },
            }
        );
    }

    getNetBankingBankList() {
        return this.http.get<any>(`${this.baseUrl}/netbanking/bank/list`);
    }

    netBankingUrl(req: NetBankingUrl) {
        return this.http.post<any>(`${this.baseUrl}/netbanking/url`, req);
    }

    netBankingCallback(token: string, status: string) {
        return this.http.get<any>(`${this.baseUrl}/netbanking/web/callback/${token}`, {
            params: { status: status },
        });
    }
}
